import fs from "fs";
import path from "path";
export const prebuildEmailTemplate = async (fetch) => {
    const template = await fetch();
    fs.writeFileSync(path.resolve() + `/src/emails/_json/${template.uid}.json`, JSON.stringify(template));
    console.log(`Write Prismic email template ${template.uid} success`);
    fs.writeFileSync(path.resolve() + `/public/email-subject-template/${template.uid}.txt`, template.subject);
    console.log(`Write Prismic email template ${template.uid} success`);
};
